export { default as ProductSlider } from './ProductSlider';
